const AIDesk = {
  "结束会话": "สิ้นสุดการสนทนากับพนักงาน",
  "转人工服务": "เปลี่ยนไปยังบริการพนักงาน",
  "跳转": "ไปยัง",
  "立即填写": "กรอกทันที",
  "已提交": "เสนอแล้ว",
  "提交": "เสนอ",
  "查看内容": "ดูเนื้อหา",
  "请填写必填项": "โปรดกรอกข้อมูลที่จำเป็น",
  "请输入内容": "กรุณากรอกเนื้อหา",
  "如果满意请给好评哦～": "หากพอใจแล้วก็อย่าลืมรีวิวให้ด้วยนะ~",
  "请对本次服务进行评价": "กรุณาประเมินบริการครั้งนี้",
  "提交评价": "ส่งการประเมิน",
  "服务评价": "การประเมินบริการ",
  "并发限制": "ปัจจุบันมีผู้ใช้งานจำนวนมาก กรุณาลองใหม่ในภายหลัง",
  "分支选项异常": "เนื้อหาผิดปกติ กรุณาตรวจสอบการตั้งค่ากระบวนการงาน",
  "满意": "พอใจ",
  "不满意": "ไม่พอใจ",
  "感谢您的反馈，我们会持续优化改进": "ขอบคุณสำหรับความคิดเห็น เราจะปรับปรุงอย่างต่อเนื่อง",
  "您遇到了哪方面的问题": "คุณประสบปัญหาด้านใด",
  "其他反馈内容": "ความคิดเห็นอื่นๆ",
  "取消": "ยกเลิก",
  "答非所问": "คำตอบไม่เกี่ยวข้อง",
  "未匹配相关内容": "ไม่พบเนื้อหาที่เกี่ยวข้อง",
  "信息错误": "ข้อมูลผิดพลาด",
  "上下文理解错误": "ความเข้าใจบริบทผิดพลาด",
  "格式不规范": "รูปแบบไม่ถูกต้อง",
  "内容不完整": "เนื้อหาไม่สมบูรณ์",
  "file 大小超过 100MB，无法发送": "ขนาดไฟล์เกิน 100MB ไม่สามารถส่งได้",
  "image 大小超过 20MB，无法发送": "ไม่สามารถส่งรูปภาพได้เนื่องจากขนาดเกิน 20 MB",
  "video 大小超过 100MB，无法发送": "ไม่สามารถส่งวิดีโอได้เนื่องจากขนาดเกิน 100 MB",
  "提交成功": "ส่งสำเร็จ",
  "userID 只能包含可打印 ASCII 字符": "UserID ต้องมีเฉพาะตัวอักษร ASCII ที่พิมพ์ได้เท่านั้น",
  "userID 不能包含'administrator'": "UserID ห้ามมี 'administrator'",
  "userID 长度不能超过45字节": "ความยาว UserID ต้องไม่เกิน 45 ไบต์",
  "我们想知道你对此回答不满意的原因，你认为更好的回答是什么？": "เราขอขอบคุณสำหรับความคิดเห็นของคุณ โปรดแบ่งปันข้อเสนอแนะใดๆ เพื่อช่วยเราปรับปรุง",
  "排队等待中": "กำลังรอคิว",
  "排队等待话术": "ขออภัย เจ้าหน้าที่ให้บริการลูกค้าทุกคนกำลังให้บริการเต็มประสิทธิภาพ กรุณารอคอยอย่างอดทน เราจะให้บริการคุณในไม่ช้า ขอบคุณสำหรับความเข้าใจ",
  "当前前方排队人数": "จำนวนผู้รอคิวด้านหน้าในขณะนี้",
  "结束排队": "ออกจากคิว",
  "评价提交超过3分钟，无法更改。感谢您的反馈！": "รีวิวที่ส่งไปแล้วเกิน 3 นาทีจะไม่สามารถแก้ไขได้",
  "不能发送空白消息": "ไม่สามารถส่งข้อความว่างได้",
  "确认转人工": "ยืนยันการโอนย้ายไปยังเจ้าหน้าที่",
}
export default AIDesk;
